import request from '@/utils/request'

export function findCpeInventories(params) {
  return request({
    url: `/cpe_inventories`,
    method: 'get',
    params
  })
}

// CPE 入库
export function importCpeInventories(data) {
  return request({
    url: `/cpe_inventories/import`,
    method: 'post',
    data
  })
}

// CPE 重新入库
export function reImportCpeInventories(data) {
  return request({
    url: `/cpe_inventories/re_import`,
    method: 'post',
    data
  })
}

// 导出库存 CPE
export function exportCpeInventories(data) {
  return request({
    url: `/cpe_inventories/export`,
    method: 'post',
    data
  })
}
